module.exports = __webpack_public_path__ + "img/care.c6515e6.webp";